var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.weatherLink && _vm.weatherLabel)?_c('div',[_c('a',{staticClass:"weatherwidget-io",attrs:{"href":_vm.weatherLink,"data-label_1":_vm.weatherLabel,"data-label_2":"WEATHER","data-font":"Verdana","data-theme":"pure"}},[_vm._v(" WEATHER ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }